import axios from 'axios'
import {HOST_API} from "../../AppConfig";
import {getFirmaLink} from "../../GlobalServices";

export const getZgloszenia = () => {
    return axios({
        method: 'GET',
        url: HOST_API + `admin/api/sygnal/firma/lista`,
        // params: {
        //     ctxFirma: getFirmaLink()
        // }
    })
}

export const getZgloszenie = (id: any) => {
    return axios({
        method: 'GET',
        url: HOST_API + `admin/api/sygnal/byId?id=${id}`,
    })
}

export const getUzytkownicy = () => {
    return axios({
        method: 'GET',
        url: HOST_API + `admin/api/dostep/lista`,
    })
}

export const addUzytkownika = (dane: any) => {
    return axios({
        method: 'POST',
        url: HOST_API + `admin/api/dostep/addDostep`,
        data: dane
    })
}

export const putKomentarz = (dane: any) => {
    return axios({
        method: 'PUT',
        url: HOST_API + `admin/api/sygnal/addKomentarz`,
        data: dane
    })
}

export const setStatus = (dane: any) => {
    return axios({
        method: 'PUT',
        url: HOST_API + `admin/api/sygnal/setStatus`,
        data: dane
    })
}

export const setAktywny = (login: any) => {
    return axios({
        method: 'PUT',
        url: HOST_API + `admin/api/dostep/odblokuj`,
        params: {
            login: login
        }
    })
}

export const setZablokuj = (login: any) => {
    return axios({
        method: 'PUT',
        url: HOST_API + `admin/api/dostep/zablokuj`,
        params: {
            login: login
        }
    })
}

export const setUsun = (login: any) => {
    return axios({
        method: 'PUT',
        url: HOST_API + `admin/api/dostep/usun`,
        params: {
            login: login
        }
    })
}

export const setHaslo = (dane: any) => {
    return axios({
        method: 'PUT',
        url: HOST_API + `admin/api/dostep/zmienHaslo`,
        data: dane
    })
}

export const login = (dane: any) => {
    return axios({
        method: 'POST',
        url: HOST_API + `admin/api/login`,
        data: dane
    })
}

export const downloadFile = (file: any) => {
    return axios({
        method: 'GET',
        url: HOST_API + 'api/plik/get/' + file.id,
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.nazwa);
        document.body.appendChild(link);
        link.click();
    })
}
